<script>
    import {
        FormGroup,
        Label,
        Input
    } from "sveltestrap";

    import { _ } from "svelte-i18n";

    export let label;
    export let name;
    export let value = null;
    export let feedback;
    export let options;
</script>

{#if options}
    <FormGroup>
        {#if label}
            <Label for={name}>{label}</Label>
        {/if}
        {#key feedback}
            {#if feedback}
                <Input type="select" {name} bind:value={value} invalid feedback={feedback} >
                    {#each options as option}
                        <option value={option.value}>{option.title}</option>
                    {/each}
                </Input>
            {:else}
                <Input type="select"  {name} bind:value={value} >
                    {#each options as option}
                        {#if option.value == value}
                            <option value={option.value} selected>{option.title}</option>
                        {:else}
                            <option value={option.value}>{option.title}</option>
                        {/if}
                    {/each}
                </Input>
            {/if}
        {/key}
    </FormGroup>
{/if}